import { render } from "./Sessions copy.vue?vue&type=template&id=fc725e38&bindings={\"classroom\":\"props\",\"sessions\":\"props\",\"flash\":\"props\"}"
import script from "./Sessions copy.vue?vue&type=script&lang=js"
export * from "./Sessions copy.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fc725e38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc725e38')) {
    api.reload('fc725e38', script)
  }
  
  module.hot.accept("./Sessions copy.vue?vue&type=template&id=fc725e38&bindings={\"classroom\":\"props\",\"sessions\":\"props\",\"flash\":\"props\"}", () => {
    api.rerender('fc725e38', render)
  })

}

script.__file = "resources/js/Pages/AssignedClassrooms/Classroom/Sessions copy.vue"

export default script